import React from 'react'

export const ClientLogo = ({ logo }) => {
  const { id, image } = logo
  return <div className="logo" key={id} style={{ backgroundImage: `url(${image})` }} />
}
